export const IMAGE_BASE_URL = "https://api2.bpetroleum.kg";